import $ from 'jquery';

global.$ = $;
global.jQuery = $;

// initial trigger dom inits
$(() => $(document).trigger('e2-dom-init', [$('body')]));
